import { InboundPartnr } from "../types/CommonTypes";

export const isEmpty = (v: any): boolean => v === null || v === undefined || v === '';

export const mergeFirstNonEmpty = (items: InboundPartnr[], emptyCheck: (v: any) => boolean = isEmpty): InboundPartnr =>
  items.reduce((acc: InboundPartnr, obj: InboundPartnr) => {
    Object.keys(obj).forEach(key => {
      const val = (obj as any)[key];
      if (!emptyCheck((acc as any)[key])) return;
      if (!emptyCheck(val)) (acc as any)[key] = val;
    });
    return acc;
  }, {} as InboundPartnr);

export default mergeFirstNonEmpty;
